import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './PriceSummary.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';
import { stayLength } from '@shared/utils-universal/guest-stay';

type Props = {
  checkIn: Date;
  checkOut: Date;
  i18n: I18nService;
};

const cls = cssModules(STYLES);

const PriceSummary = ({
  checkIn,
  checkOut,
  i18n: { translatePlural },
}: Props) => {
  const nightCount = stayLength({
    checkIn,
    checkOut,
  });

  return (
    <div className={cls('PriceSummary')}>
      <div className={cls('PriceSummary__night')}>
        <BpkText tagName="p">
          {nightCount &&
            translatePlural(
              'SelectionSummary_label_nights',
              nightCount,
              'number',
            )}
        </BpkText>
      </div>
    </div>
  );
};

export default withI18n(PriceSummary);
